import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { StatItem, StatKey } from './ajutoare-stats.types';
import { AjutoareStatsModalComponent } from './ajutoare-stats-modal/ajutoare-stats-modal.component';

@Component({
    selector: 'app-ajutoare-stats-bar',
    templateUrl: './ajutoare-stats-bar.component.html',
    styleUrls: ['./ajutoare-stats-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AjutoareStatsBarComponent {
    @Input() stats: StatItem[] = [];
    @Input() lastUpdated?: Date;
    @Input() activeKey: StatKey | null = null;
    @Output() statSelected = new EventEmitter<StatKey>();
    @Output() resetFilter = new EventEmitter<void>();

    constructor(private dialog: MatDialog) {}

    get activeStats(): StatItem[] {
        return this.stats.filter(s => s.count > 0);
    }

    get totalCount(): number {
        return this.stats.reduce((sum, s) => sum + s.count, 0);
    }

    get totalLabel(): string {
        return this.totalCount === 1 ? 'cerere activă' : 'cereri active';
    }

    onPillClick(key: StatKey): void {
        this.statSelected.emit(key);
    }

    onReset(): void {
        this.resetFilter.emit();
    }

    openModal(): void {
        const dialogRef = this.dialog.open(AjutoareStatsModalComponent, {
            width: '480px',
            maxWidth: '95vw',
            panelClass: 'ajutoare-stats-dialog-panel',
            autoFocus: 'first-tabbable',
            restoreFocus: true,
            data: {
                stats: this.stats,
                totalCount: this.totalCount,
                lastUpdated: this.lastUpdated,
                activeKey: this.activeKey,
            },
        });

        dialogRef.afterClosed().subscribe((selectedKey: StatKey | undefined) => {
            if (selectedKey) {
                this.statSelected.emit(selectedKey);
            }
        });
    }

    trackByKey(_: number, stat: StatItem): string {
        return stat.key;
    }
}
